// extracted by mini-css-extract-plugin
export var required = "_i6-0";